import styled from "styled-components"

export const Container = styled.div`
    position: absolute;
    left: 0;
  margin-top: 8rem;
  width: 100%;
  background-color: #982822;
  @media (max-width: 1000px){
        flex-direction: column;
        margin-top: 2rem;
        padding-bottom: 2rem;
    }
`;

export const Baseline = styled.h3`
    color: white;
    font-size: 20px;
    font-weight: 500;
    text-transform: none;
    margin-top: 3rem;
    @media(max-width: 1000px){
        font-size: 16px;
    }
`

export const Title = styled.h1`
    color: white;
    margin-top: 2rem;
    @media(max-width: 1000px){
        font-size: 60px;
    }
`

export const Info = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    .phone, .email{
        display: flex;
        height: 45px;
        align-items: center;
        margin: 0 2rem;
        >img{
            height:100%;
            margin-right: 1.5rem;
        }
        >p{
            margin: 1rem 1rem 1rem 0;
            color: white;
        }
    }
    @media(max-width: 1000px){
        flex-direction: column;
        .phone, .email{
        display: flex;
        height: 30px;
        align-items: center;
        margin: 0.5rem;
        >img{
            height:100%;
            margin-right: 1rem;
        }
        >p{
            margin: 0;
            color: white;
        }
    }
    }
`

export const SocialMedia = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    margin-bottom: 3rem;
    >a{
        height: 80px;
        margin: 1rem;
        max-width: 100%;
        >img{
            height:100%;
            max-width: 100%;
        }
    }
    >a:hover{
        cursor: pointer;
    }
    .facebook{
        background-color: white;
    }
    @media(max-width: 1000px){
        >a{
        height: 40px;
        margin: 1rem;    
        }   
    }
`